/*
 * @description: 
 * @author: Jason Wong
 * @since: 2021-01-28 10:25:25
 */
import $$loader from './elementExtensions/loader'
import $$try from './elementExtensions/try';
import IEnumerable from './IEnumerable'
import canvasUtil from './canvas'
import dateTimeExtension from './dateTime'
import Vue from 'vue'
import './range';
import './directives/editDIv';

export default {
    use(){
        Vue.use($$loader);
        Vue.use($$try);
        IEnumerable.use();
        canvasUtil.use();
        dateTimeExtension.use();
    }
}